module.exports = __webpack_public_path__ + "media/images/pictograms/pic7-4c1a5a92dbceb8734559ec277ea9a751.png";